import React from 'react';

const GemIcon = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={20}
      height={20}
      viewBox='0 0 20 20'
      fill='none'
      {...props}
    >
      <path
        d='M15.5448 16.3357V3.77926L9.99993 0.577911L4.45508 3.77926V16.3357L9.99993 19.5371L15.5448 16.3357Z'
        fill='#22C55E'
      />
      <path
        d='M10.0002 19.5371L15.5451 16.3357V3.77926L10.0002 0.577911V19.5371Z'
        fill='#15803D'
      />
      <path
        d='M13.6409 14.6038V5.39552L9.99915 3.29297L6.35742 5.39552V14.6038L9.99915 16.7063L13.6409 14.6038Z'
        fill='#86EFAC'
      />
      <path
        d='M10 16.7063L13.6417 14.6038V5.39552L10 3.29297V16.7063Z'
        fill='#22C55E'
      />
      <path
        d='M13.6426 5.39494L15.5457 3.77734V16.3338L13.6426 14.6032V5.39494Z'
        fill='#86EFAC'
      />
      <path
        d='M6.3582 5.39494L4.45508 3.77734V16.3338L6.3582 14.6032V5.39494Z'
        fill='#DCFCE7'
      />
    </svg>
  );
};

export default GemIcon;
